import React from 'react'
import { withRouter } from 'react-router-dom'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import { connect } from 'react-redux'
import './sales.styles.scss'
import Service from './sales.service'
import NumberFormat from 'react-number-format'

class Sales extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    onPageChange = page => {
        this.setState({
            ...this.state,
            currentPage: page
        }, () => this.service.loadSales())
    }

    onFilterChange = e => {
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                value: "",
                [e.target.name]: e.target.value
            }
        })
    }

    onFilterChange = e => {
        this.setState({
            ...this.state,
            criteria: {
                ...this.state.criteria,
                [e.target.name]: e.target.value
            }

        })
    }

    onFilterSubmit = e => {
        e.preventDefault()
        this.service.loadSaleReport()
    }

    getSummary() {
        let sumAmount = 0
        let sumTotal = 0

        this.state.orderReport.forEach(report => {
            sumTotal += Number(report.total)
            sumAmount += Number(report.amount)
        });

        return {
            total: sumTotal,
            amount: sumAmount
        }
    }

    render() {
        let summary = this.getSummary()
        return (
            <>
                {this.state.loadingSaleReport && <Dialog><Loading /></Dialog>}
                <div className="sales">
                    <div className="header">
                        <h4>Sales Report</h4>
                        <form>
                            <div className="row" id="type">
                                <div className="form-label">
                                    <label>Type</label>
                                </div>
                                <div className="form-input">
                                    <select name="type" onChange={this.onFilterChange} value={this.state.criteria.type}>
                                        <option value="daily">Daily</option>
                                        <option value="monthly">Monthly</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row" id="from">
                                <div className="form-label">
                                    <label>From</label>
                                </div>
                                <div className="form-input">
                                    <input type="date" name="from" onChange={this.onFilterChange} value={this.state.criteria.from} />
                                </div>
                            </div>
                            <div className="row" id="from">
                                <div className="form-label">
                                    <label>To</label>
                                </div>
                                <div className="form-input">
                                    <input type="date" name="to" onChange={this.onFilterChange} value={this.state.criteria.to} />
                                </div>
                            </div>
                            <div className="row">
                                <button type="submit" onClick={this.onFilterSubmit}>Apply</button>
                            </div>
                        </form>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Total</th>
                                <th>Amount(₦)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.orderReport.map((report, key) => <tr key={key}>
                                    <td>{report.date}</td>
                                    <td><NumberFormat value={report.total} displayType={'text'} thousandSeparator={true} renderText={value => value} /></td>
                                    <td><NumberFormat value={report.amount / 100} displayType={'text'} thousandSeparator={true} renderText={value => value} /></td>
                                </tr>)

                            }
                        </tbody>
                        {
                            this.state.orderReport.length > 0 && <>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th><NumberFormat value={summary.total} displayType={'text'} thousandSeparator={true} renderText={value => value} /></th>
                                        <th><NumberFormat value={summary.amount / 100} displayType={'text'} thousandSeparator={true} renderText={value => value} /></th>
                                    </tr>
                                </thead>
                            </>
                        }
                    </table>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(Sales))